var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalBase',{staticClass:"modal_box is-init",scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('Loader')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }